import { render, staticRenderFns } from "./FbVideo.vue?vue&type=template&id=a3440d20&scoped=true"
import script from "./FbVideo.vue?vue&type=script&lang=js"
export * from "./FbVideo.vue?vue&type=script&lang=js"
import style0 from "./FbVideo.vue?vue&type=style&index=0&id=a3440d20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3440d20",
  null
  
)

export default component.exports